module.exports = __webpack_public_path__ + "static/media/whatsapp.e9db5e7b.svg";